const PILLARS = [
  { title: "NDIS Registered", text: "Strict quality & safeguard standards met across every support." },
  { title: "Small & Personal", text: "Direct access to your care team without call-centre handoffs." },
  { title: "Statewide SA", text: "Metro Adelaide, Adelaide Hills, regional & rural South Australia." },
  { title: "Self-Booking", text: "Select available times directly or drop an enquiry in seconds." },
];

export default function Pillars() {
  return (
    <section className="border-y border-[#EAE3D7] bg-[#F4EFE6]/60 py-8 px-5 sm:px-8" data-testid="pillars-section">
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 text-left">
        {PILLARS.map((p) => (
          <div className="space-y-1" key={p.title}>
            <div className="text-xs font-semibold uppercase tracking-wider text-[#736353]">{p.title}</div>
            <p className="text-sm text-[#435056]">{p.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
